export default "__VITE_ASSET__CCqN6EWK__"